import {
  GetWorkOrdersForDeveloperRequest,
  WorkOrdersApi,
  WorkOrdersWorkOrder,
} from "@ionenergysolutions/reporting-api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useApi } from "./useApi";

const getCacheKey = (request: GetWorkOrdersForDeveloperRequest) => ["work-orders", request];

type PaginatedWorkOrdersWorkOrder = {
  results: WorkOrdersWorkOrder[];
  total: number;
};

export const useWorkOrders = <T = PaginatedWorkOrdersWorkOrder>(
  request: GetWorkOrdersForDeveloperRequest,
  options?: UseQueryOptions<PaginatedWorkOrdersWorkOrder, Error, T>,
) => {
  const api = useApi(WorkOrdersApi);
  const query = useQuery<PaginatedWorkOrdersWorkOrder, Error, T>(
    getCacheKey(request),
    async () => {
      try {
        const response = await api.getWorkOrdersForDeveloperRaw(request);
        const total = parseInt(response.raw.headers.get("x-total-count") || "", 10) || 0;
        const results = await response.value();
        return { total, results };
      } catch (e: unknown) {
        const response = e as Response;
        const json = await response.json();
        const message = json.message || response.statusText;
        throw new Error(message);
      }
    },
    options,
  );
  return query;
};
